/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';
import { dropTask } from 'ember-concurrency';
import DomainModel from 'cio/models/domain';

interface DomainMailServersDedicatedRequestFormArgs {
  title: string;
  domain: DomainModel;
  onRequest: ({ volume, comments }: { volume: string; comments: string }) => unknown;
}

export default class DomainMailServersDedicatedRequestForm extends Component<DomainMailServersDedicatedRequestFormArgs> {
  @tracked dailyVolume = '';
  @tracked comments = '';

  get canRequest() {
    return !isEmpty(this.dailyVolume);
  }

  requestTask = dropTask(async (ev: Event) => {
    ev.preventDefault();
    return this.args.onRequest({ volume: this.dailyVolume, comments: this.comments });
  });
}
